var Backbone, SupportAPIHelper, SupportGiftOrderPopupFormTemplate, SupportGiftOrderPopupView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportAPIHelper = require('../../helpers/API');

SupportGiftOrderPopupFormTemplate = require('../../../gift_order_popup_form.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

SupportGiftOrderPopupView = (function(superClass) {
  extend(SupportGiftOrderPopupView, superClass);

  function SupportGiftOrderPopupView() {
    return SupportGiftOrderPopupView.__super__.constructor.apply(this, arguments);
  }

  SupportGiftOrderPopupView.prototype.id = 'giftpopupContent';

  SupportGiftOrderPopupView.prototype.initialize = function(options) {
    this.options = options || {};
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportGiftOrderPopupFormTemplate;
    this.order = Groupon.Support.currentOrder;
    this.attributes = this.options.userId;
    this.isEmail = true;
    return this.render();
  };

  SupportGiftOrderPopupView.prototype.render = function() {
    this.popup = $('#popup');
    GIG.Modal.open({
      el: this.popup,
      closeOnBgClick: true,
      closeOnEscKey: true
    });
    this.popup.html(toHtml(this.template, {}, this.I18nScope));
    this.giftEmailDeliveryType = $('#emailType');
    this.saveBtn = $('#gift_details_save_btn');
    this.recipientName = $('#order_gift_recipient_name');
    this.senderName = $('#order_gift_from_name');
    this.recipientEmail = $('#order_gift_recipient_email');
    this.message = $('#order_gift_message');
    this.giftEmailDeliveryType.prop('checked', true);
    this.validateToField = $('#validate_to_field');
    this.validateFromField = $('#validate_from_field');
    this.validateEmail = $('#validate_email');
    this.saveBtn.bind("click", this.saveBtnHandler);
    $("input:radio[name=deliveryType]").click(function(ev) {
      var emailInput;
      emailInput = $('#order_gift_recipient_email');
      if (ev.currentTarget.id === "emailType") {
        this.isEmail = true;
        return emailInput.removeAttr('disabled');
      } else {
        this.isEmail = false;
        emailInput.val("");
        return emailInput.prop('disabled', 'disabled');
      }
    });
    return $('#order_gift_message').keyup(function(ev) {
      var content, max, msgDiv, remaining;
      max = 330;
      msgDiv = $('#order_gift_message');
      content = msgDiv.val();
      if (content.length >= max) {
        remaining = 0;
        return $('#noOfChars').text(remaining + " characters");
      } else {
        remaining = max - content.length;
        if (remaining === 1) {
          return $('#noOfChars').text(remaining + " character");
        } else {
          return $('#noOfChars').text(remaining + " characters");
        }
      }
    });
  };

  SupportGiftOrderPopupView.prototype.clearValidationMessages = function() {
    this.validateToField.text('');
    this.validateFromField.text('');
    return this.validateEmail.text('');
  };

  SupportGiftOrderPopupView.prototype.validate = function() {
    var email, validationPass;
    validationPass = true;
    this.clearValidationMessages();
    if (this.recipientName.val().length === 0) {
      this.validateToField.text('Field cannot be empty');
      validationPass = false;
    }
    if (this.senderName.val().length === 0) {
      this.validateFromField.text('Field cannot be empty');
      validationPass = false;
    }
    if (this.isEmail === true) {
      email = this.recipientEmail.val();
      if (!this.validateEmailAddress(email)) {
        this.validateEmail.text('Enter valid email address');
        validationPass = false;
      }
    }
    return validationPass;
  };

  SupportGiftOrderPopupView.prototype.validateEmailAddress = function(email) {
    var re;
    re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };

  SupportGiftOrderPopupView.prototype.saveBtnHandler = function() {
    var data, errorCallback, options, successCallback, url;
    if (!this.validate()) {
      return;
    }
    successCallback = this.closePopup;
    errorCallback = this.renderErrorPage;
    data = {};
    data.module_name = 'contact_us_ajax';
    data.method_name = 'giftOrder';
    options = {};
    options.gift_to_name = this.recipientName.val();
    options.gift_from_name = this.senderName.val();
    if (this.isEmail === true) {
      options.gift_recipient_email_address = this.recipientEmail.val();
      options.gift_delivery_method = "email";
    } else {
      options.gift_delivery_method = "print";
    }
    options.gift_message = this.message.val();
    options.order_id = Groupon.Support.currentOrder.id;
    options.deal_id = Groupon.Support.currentOrder.deal.id;
    url = window.SUPPORTBASEURL + "/getData";
    data = {};
    data.module_name = "orders_update";
    data.method_name = "giftOrder";
    data.options = options;
    return SupportAPIHelper.get(url, data, successCallback, errorCallback, true);
  };

  SupportGiftOrderPopupView.prototype.renderErrorPage = function() {
    return flash('error', "Error when contacting server for gift order action");
  };

  SupportGiftOrderPopupView.prototype.closePopup = function() {
    GIG.Modal.close();
    return false;
  };

  SupportGiftOrderPopupView.prototype.events = {
    "click #gift_details_cancel_btn": "closePopup"
  };

  return SupportGiftOrderPopupView;

})(Backbone.View);

module.exports = SupportGiftOrderPopupView;

//# sourceMappingURL=data:application/json;base64,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
